// dashboardConfig.ts

import { MailOutlined, LineChartOutlined, CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { ReactNode } from 'react';

// --- Activity Card Types ---
export type ActivityData = {
  title: string;
  count: number;
  total: number;
  icon: ReactNode;
  iconBg: string; // Tailwind background class
  iconColor: string; // Tailwind text color class
  countColor: string; // Tailwind text color for the count
};

export const leadActivityConfig: ActivityData[] = [
  {
    title: 'Leads Created',
    count: 20,
    total: 30,
    icon: <MailOutlined />,
    iconBg: 'bg-orange-100',
    iconColor: 'text-orange-500',
    countColor: 'text-orange-500',
  },
  {
    title: 'Leads Converted',
    count: 20,
    total: 30,
    icon: <LineChartOutlined />,
    iconBg: 'bg-teal-100',
    iconColor: 'text-teal-500',
    countColor: 'text-teal-500',
  },
  {
    title: 'Leads Won',
    count: 20,
    total: 30,
    icon: <CheckCircleOutlined />,
    iconBg: 'bg-green-100',
    iconColor: 'text-green-500',
    countColor: 'text-green-500',
  },
  {
    title: 'Leads Lost',
    count: 20,
    total: 30,
    icon: <CloseCircleOutlined />,
    iconBg: 'bg-red-100',
    iconColor: 'text-red-500',
    countColor: 'text-red-500',
  },
];

export const dealActivityConfig: ActivityData[] = [
  {
    title: 'deal Created',
    count: 20,
    total: 30,
    icon: <MailOutlined />,
    iconBg: 'bg-orange-100',
    iconColor: 'text-orange-500',
    countColor: 'text-orange-500',
  },
  {
    title: 'deal Converted',
    count: 20,
    total: 30,
    icon: <LineChartOutlined />,
    iconBg: 'bg-teal-100',
    iconColor: 'text-teal-500',
    countColor: 'text-teal-500',
  },
  {
    title: 'deal Won',
    count: 20,
    total: 30,
    icon: <CheckCircleOutlined />,
    iconBg: 'bg-green-100',
    iconColor: 'text-green-500',
    countColor: 'text-green-500',
  },
  {
    title: 'deal Lost',
    count: 20,
    total: 30,
    icon: <CloseCircleOutlined />,
    iconBg: 'bg-red-100',
    iconColor: 'text-red-500',
    countColor: 'text-red-500',
  },
];


// --- Pipeline Stage Types ---
export type PipelineStageData = {
  stage: string;
  count: number;
  stageColor: string; // Tailwind text color class for the stage name
  countBg: string; // Tailwind background class for the count badge
  countColor: string; // Tailwind text color class for the count badge
};

export const leadPipelineConfig: PipelineStageData[] = [
  { stage: 'Attempt to Contact', count: 12, stageColor: 'text-gray-500', countBg: 'bg-yellow-50', countColor: 'text-yellow-600' },
  { stage: 'Contacted', count: 12, stageColor: 'text-gray-500', countBg: 'bg-yellow-50', countColor: 'text-yellow-600' },
  { stage: 'Contact in Future', count: 12, stageColor: 'text-gray-500', countBg: 'bg-yellow-50', countColor: 'text-yellow-600' },
  { stage: 'Junk Lead', count: 12, stageColor: 'text-gray-500', countBg: 'bg-yellow-50', countColor: 'text-yellow-600' },
  { stage: 'Lost Lead', count: 12, stageColor: 'text-gray-500', countBg: 'bg-yellow-50', countColor: 'text-yellow-600' },
  { stage: 'Not Contacted', count: 12, stageColor: 'text-gray-500', countBg: 'bg-yellow-50', countColor: 'text-yellow-600' },
];

export const dealPipelineConfig: PipelineStageData[] = [
  { stage: 'Screening Round', count: 12, stageColor: 'text-gray-500', countBg: 'bg-cyan-50', countColor: 'text-cyan-600' },
  { stage: 'Technical Round', count: 12, stageColor: 'text-gray-500', countBg: 'bg-cyan-50', countColor: 'text-cyan-600' },
  { stage: 'Managerial Round', count: 12, stageColor: 'text-gray-500', countBg: 'bg-cyan-50', countColor: 'text-cyan-600' },
  { stage: 'Budget Discussion', count: 12, stageColor: 'text-gray-500', countBg: 'bg-cyan-50', countColor: 'text-cyan-600' },
  { stage: 'Closed Won', count: 12, stageColor: 'text-green-500', countBg: 'bg-cyan-50', countColor: 'text-cyan-600' },
  { stage: 'Closed Lost', count: 12, stageColor: 'text-red-500', countBg: 'bg-cyan-50', countColor: 'text-cyan-600' },
  // Note: The design uses different background colors for lead vs. deal counts.
];